export class StringConstants {
  //contentTypes
  applicationJSON = { "Content-Type": "application/json" };
  multipartForm = {};

  // Request Methods
  POST = "POST";
  GET = "GET";
  PATCH = "PATCH";
  PUT = "PUT";

  // Order Type
  ORDER = "Order";
  PAY = "Pay";

  DINEIN = "DINEIN";

  //itemOptions
  required = "REQUIRED";
  optional = "OPTIONAL";
  completed = "COMPLETED";
  multiple = "MULTIPLE";
  single = "SINGLE";
  priceLevel = "Price Level";

  //Restaurant is closed
  RESTAURANT_CLOSE = "This restaurant is currently closed.";
  RESTAURANT_CLOSE_MATCH = "Restaurant is closed.";
  RESTAURANT_CLOSE_PICKUP_MATCH = "Restaurant is closed for pickup.";

  pageNotFound = "pageNotFound";
  notification = "notification";
  socketEmit = "socketEmit";
  error = "error";
  success = "success";
  warning = "warning";
  info = "info";
  autoHideDuration = 600 * 1000; //in milliseconds

  //date
  am = "AM";
  pm = "PM";

  LEGAL_AGE = "21";
  ALCOHOL = "alcohol";

  // Card types
  visa = "visa";
  masterCard = "master";
  amex = "american_express";
  jcb = "jcb";
  discover = "discover";

  // Promo Code
  PROMO_CODE_APPLIED = "Code has been successfully applied!";
  PROMO_CODE_REMOVED = "Code has been removed!";

  // Message Suggestions
  messages = [
    "I need utensils",
    "Can I have an extra dish?",
    "Can I get a refill on my drink?",
  ];
  emptyMessage = "Please enter the message";

  SEARCH_TIME_OUT = 350;
  SET_TIME_OUT = 3000;

  // TAB Strings
  TABSCREENTITLE = "Order and Pay here."; // TODO: Remove Later
  TABSCREENSUBTITLE = "Your orders will appear here once you place them."; // TODO: Remove Later

  PAYSCREEN_SPLITNPAY_TITLE = "No orders on your check";
  PAYSCREEN_SPLITNPAY_DESC =
    "Your orders will appear here once your server places them. You can split and pay for check between the guests at your table here.";

  PAYSCREEN_ORDERING_TITLE = "No orders placed";
  PAYSCREEN_ORDERING_DESC =
    "Orders added to your check will appear here. Orders may take up to 90 seconds to appear. You can split and pay your check between the guests at your table here.";

  TABSCREENDEMOTEXT =
    "Normally when dining in with Glyde, you can keep an open tab running to keep adding items to your session. For this demo, we have it disabled to order quickly.";

  itemAdded = "Item has been added to cart";

  // PAYMENT
  TABORNOT =
    "Order at your convenience. Leave when done, you will be charged automatically.";
  DOLLAR100DISCLAIMER =
    "A $100 hold will be placed on your credit card, and will be cancelled once you close the tab.";

  glydeLoadingImage = "Glyde Loading Image";

  // custom loading gif check
  CHECKOUT = "CHECKOUT";
  FALLBACK = "FALLBACK";
  START_TAB = "Start tab";

  // Express Checkout
  OTP_RESEND_TIME = 60;
  RESEND_OTP_SUCCESS = "New OTP has been sent to your mobile number!";

  // Demo User Details
  DEMO_USERNAME = "Demo User";
  DEMO_EMAIL = "demo@glyde.app";
  DEMO_CONTACT_NUMBER = "9876543210";

  // All ITEMS MENU BY ID
  allItems = "All Items";

  DISCLAIMER_MSG =
    'By clicking Place Order, you consent to receive communications, such as e-mails, texts, SMS or MMS messages, from us and / or our third-party partners on our behalf, at the phone number or email you provided. To unsubscribe from order-related messages, reply with "STOP" to the number sending the message.';

  // SUCCESS MESSAGE
  sendTextMessageSuccess =
    "Thanks! You'll shortly receive a text message with the link.";

  TABCLOSED = "Tab Closed";
  CLOSESESSION = "Close Tab";

  TABCLOSEDWARNING = "The tab is closed!";

  // ReCAPTCHA
  siteKey = "6LfGvwYeAAAAACeyBGNoyBci_biqp-ZTE8VtxqCZ";

  ORDERPLACESUCCESS = "Your order was placed successfully.";

  // google merchant id
  merchantId = "BCR2DN6T3OQITMQW";

  captureLater = true;

  userAvatarColors = [
    "#E0BBE4",
    "#957DAD",
    "#FFDFD3",
    "#9BB8ED",
    "#C6DFCD",
    "#F5F2D3",
    "#E6D5C3",
    "#C9A8A0",
    "#737D89",
    "#869F9F",
    "#8CBDBD",
    "#C5D8AB",
    "#80BFA0",
    "#C56E90",
    "#FF9C9C",
    "#8DE0E0",
    "#FFF9AB",
    "#FFA3D6",
    "#A16FDD",
    "#679A7D",
    "#ED8EA4",
  ];

  CREDITCARD = "CreditCard";
  APPLEPAY = "ApplePay";
  GPAY = "GooglePay";

  TAB_ACCEPTED_CARDS = ["visa", "mastercard"];

  // DEMO THANKYOU PAGE
  DEMO_THANKYOU_TITLE = "Thank you for using Glyde!";
  DEMO_THANKYOU_SUBTITLE =
    "Book a comprehensive demo on how our product is changing the way guests interact at restaurants; increasing table turnover rates and check sizes!";

  // aws RUM

  //dev
  dev_guestRoleArn =
    "arn:aws:iam::785023135240:role/RUM-Monitor-us-east-1-785023135240-7854395069661-Unauth";
  dev_identityPoolId = "us-east-1:1d38ecce-1f9c-4b22-b260-4760f9074894";
  dev_APPLICATION_ID = "ce188650-8598-4053-bdb6-07a15bc259ea";

  // stage
  stage_guestRoleArn =
    "arn:aws:iam::785023135240:role/RUM-Monitor-us-east-1-785023135240-5980998629661-Unauth";
  stage_identityPoolId = "us-east-1:c2376d31-184f-49f6-b42d-d6dbab77bca1";
  stage_APPLICATION_ID = "c623b2b4-e525-4576-923a-ffc6e413174b";

  //prd
  prod_guestRoleArn =
    "arn:aws:iam::785023135240:role/RUM-Monitor-us-east-1-785023135240-3911719629661-Unauth";
  prod_identityPoolId = "us-east-1:7f4c37fb-9cd5-4273-913c-3a50d114e8e5";
  prod_APPLICATION_ID = "55f9264a-9f98-4e6c-957d-4ac7e3960eee";

  AWS_RUM_APPLICATION_VERSION = "1.0.0";
  AWS_RUM_REGION = "us-east-1";

  // Payment Processors
  heartland = "heartland";
  square = "square";

  VERTICAL = "VERTICAL";
  HORIZONTAL = "HORIZONTAL";

  highLightProjectIdForProd = "lgxv2qdm";

  // Payment Mode
  CARDPAYMENT = "CardPayment";
  ADOPTACARDPAYMENT = "AdoptACardPayment";

  CARTS = "Carts";

  // Regex
  EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  RETRY_AUTH_CAPTURE = 2;

  // PostHog
  REACT_APP_PUBLIC_POSTHOG_KEY =
    "phc_KxPHX8UcaOEiyYkR36wmVIWzJ6pkarYAMZHRuIUsBzd";
  REACT_APP_PUBLIC_POSTHOG_HOST = "https://app.posthog.com";
}

let strings = new StringConstants();
export default strings;
